const { getFeatureConfig } = require('../helpers/utils');
const { nodeHelper } = require('../helpers/node-helpers');
const { formatUrl, getLocalObjectUrl, getLocalObjectAlt } = require('../helpers/app-helpers.js');

const featureConfig = getFeatureConfig('objectMapping');

// For backward compatibility, this should be removed after code refactoring.
const globalConfig = require('../../config');
const { isProxy } = require('../helpers/mode.js');
/**
 * Perform initialization tasks for this feature
 *
 * @param {object} config Configuration passed by initialization code
 */
exports.initialize = async (config) => {
  featureConfig.enabled = config.enable_object_mapping;
};

/**
 * Is used to check if the feature is enabled or not.
 *
 * @returns boolean
 */
exports.isEnabled = () => {
  return !!featureConfig.enabled;
};

/**
 * Traverse over nodes to localized media/asset urls.
 *
 * @param {object} node Single dom node
 * @param {function|undefined} callback Callback to handle post tracversing action
 * @returns object
 */
exports.traverseNodes = async (node, callback) => {
  if (nodeHelper(node).isAnImage()) {
    for await (const handler of handlers) {
      node = await handler(node);
    }
  }

  if (nodeHelper(node).isAnAudio()) {
    for await (const handler of handlers) {
      node = await handler(node);
    }
  }

  if (node.nodeName && node.nodeName.toUpperCase() === 'SPAN') {
    if (node.getAttribute('data-audio-meta') == 'path') {
      for await (const handler of handlers) {
        node = await handler(node);
      }
    }
  }

  // if (node.nodeName && node.nodeName.toUpperCase() === 'A') {
  //   for await (const handler of handlers) {
  //     node = await handler(node);
  //   }
  // }

  // if (nodeHelper(node).isAnIframe() && !globalConfig.enable_youtube_iframe) {
  //   for await (const handler of handlers) {
  //     node = await handler(node);
  //   }
  // }

  return node;
};

/**
 * Various handlers to perform different actions on given node.
 */
const handlers = [
  async (node) => {
    if (node.src) {
      let localUrl = '';
      let objectEnglishUrl = node.src;

      // If the url is absolute
      if (node.src.includes('http')) {
        let requested_domain = !globalConfig.requested_domain.endsWith('/')
          ? globalConfig.requested_domain + '/'
          : globalConfig.requested_domain;
        let domain = !globalConfig.domain.endsWith('/')
          ? globalConfig.domain + '/'
          : globalConfig.domain;
        if (isProxy() && requested_domain != '/') {
          objectEnglishUrl = node.src.replaceAll(requested_domain, domain);
        }
      } else if (node.src.startsWith('/')) {
        objectEnglishUrl = `${globalConfig.domain}${node.src}`;
      } else {
        objectEnglishUrl = `${globalConfig.domain}/${node.src}`;
      }
      localUrl = getLocalObjectUrl(objectEnglishUrl);

      const localAlt = getLocalObjectAlt(objectEnglishUrl);

      if (localUrl) {
        node.src = localUrl;
      }
      if (localAlt) {
        node.alt = localAlt;
      }
    } else if (node.href) {
      let localUrl = '';
      let objectEnglishUrl = node.href;

      // If the url is absolute
      if (node.href.includes('http')) {
        let requested_domain = !globalConfig.requested_domain.endsWith('/')
          ? globalConfig.requested_domain + '/'
          : globalConfig.requested_domain;
        let domain = !globalConfig.domain.endsWith('/')
          ? globalConfig.domain + '/'
          : globalConfig.domain;
        if (isProxy() && requested_domain != '/') {
          objectEnglishUrl = node.href.replaceAll(requested_domain, domain);
        }
      } else if (node.href.startsWith('/')) {
        objectEnglishUrl = `${globalConfig.domain}${node.href}`;
      } else {
        objectEnglishUrl = `${globalConfig.domain}/${node.href}`;
      }
      localUrl = getLocalObjectUrl(objectEnglishUrl);
      const blacklistedLinks = ['about:blank', 'javascript:void(0)', 'tel:', 'mailto:'];
      const hrefDoesNotIncludesAnyBlacklistedLink = blacklistedLinks
        .map((blacklistedLink) => node && node.href && !node.href.includes(blacklistedLink))
        .every(Boolean);

      console.log('objectEnglishUrl', hrefDoesNotIncludesAnyBlacklistedLink);

      localUrl = getLocalObjectUrl(objectEnglishUrl);
      if (
        node.href &&
        hrefDoesNotIncludesAnyBlacklistedLink &&
        localUrl &&
        localUrl !== node.href
      ) {
        node.href = localUrl;
      }
    } else if (node.textContent) {
      let localUrl = '';
      let objectEnglishUrl = node.textContent;

      // If the url is absolute
      if (node.textContent.includes('http')) {
        let requested_domain = !globalConfig.requested_domain.endsWith('/')
          ? globalConfig.requested_domain + '/'
          : globalConfig.requested_domain;
        let domain = !globalConfig.domain.endsWith('/')
          ? globalConfig.domain + '/'
          : globalConfig.domain;
        if (isProxy() && requested_domain != '/') {
          objectEnglishUrl = node.textContent.replaceAll(requested_domain, domain);
        }
      } else if (node.textContent.startsWith('/')) {
        objectEnglishUrl = `${globalConfig.domain}${node.textContent}`;
      } else {
        objectEnglishUrl = `${globalConfig.domain}/${node.textContent}`;
      }

      const blacklistedLinks = ['about:blank', 'javascript:void(0)', 'tel:', 'mailto:'];
      const hrefDoesNotIncludesAnyBlacklistedLink = blacklistedLinks
        .map((blacklistedLink) => !node && !node.href && !node.href.includes(blacklistedLink))
        .every(Boolean);

      localUrl = getLocalObjectUrl(objectEnglishUrl);
      if (localUrl) {
        node.textContent = localUrl;
      }
    }
    return node;
  },

  async (node) => {
    if (node.getAttribute('srcset')) {
      const value = node.getAttribute('srcset');
      let valueWithLocalLinks = value;
      Object.values(globalConfig.subdomain_object_urls_hash_map).forEach((object) => {
        valueWithLocalLinks = valueWithLocalLinks.replaceAll(
          formatUrl(object.english_url),
          formatUrl(object.local_url)
        );
      });
      node.setAttribute('srcset', valueWithLocalLinks);
    }
    return node;
  },

  async (node) => {
    if (node.getAttribute('data-lazy-src')) {
      const value = node.getAttribute('data-lazy-src');
      let valueWithLocalLinks = value;

      Object.values(globalConfig.subdomain_object_urls_hash_map).forEach((object) => {
        valueWithLocalLinks = valueWithLocalLinks.replaceAll(
          formatUrl(object.english_url),
          formatUrl(object.local_url)
        );
      });
      node.setAttribute('data-lazy-src', valueWithLocalLinks);
    }
    return node;
  },

  async (node) => {
    if (node.getAttribute('data-lazy-srcset')) {
      const value = node.getAttribute('data-lazy-srcset');
      let valueWithLocalLinks = value;
      Object.values(globalConfig.subdomain_object_urls_hash_map).forEach((object) => {
        valueWithLocalLinks = valueWithLocalLinks.replaceAll(
          formatUrl(object.english_url),
          formatUrl(object.local_url)
        );
      });
      node.setAttribute('data-lazy-srcset', valueWithLocalLinks);
    }
    return node;
  }
];
